<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Módulo de Crédito"
			sub="Relatórios"
		>
    </page-title>

		<!-- Filter -->
    <card>
      <div class="row ">
        <h5 class="col-12 h2 mb-0 mb-2">Relatórios</h5>
        <h5 class="col-12 card-title text-uppercase text-muted mb-4 h5">relatórios referentes ao processo de solicitação e liberação de crédito</h5>
        <div class="row col-12 d-flex justify-content-between">
          <div class="card-deck col-3 ml-1" v-for="report in reports" :key="report.id">
            <div class="card mb-3">
              <div class="card-header row d-flex justify-content-center" style="min-height: 7rem">
                  <i :class="'mt-2 text-gray fa fa-' + `${report.icon}`" style="cursor: pointer; font-size: 58px"/>
              </div>
              <div 
                class="card-body bg-blue text-white row d-flex justify-content-center text-center align-center" 
                style="max-height: 6.5rem; border-radius: 0px 0px 4px 4px;"
              >
                <h5 class="text-white" style="font-size: 13px; font-weight: 600;">{{ report.description }}</h5>
                <a :href="report.link" class="col-12 text-white stretched-link fs-6" style="font-size: 14px; text-decoration: underline;">Ver relatórios</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
	</div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle"

export default {
  name: 'reports',
  components: { 
    PageTitle
  },
  data() {
    return {
       reports: [
        {
          id: 1,
          description: 'Relatórios de clientes participantes do sistema de análise de crédito',
          icon: 'users'
        },
        {
          id: 2,
          description: 'Relatórios de propostas',
          icon: 'calendar-alt',
          link: '/cri/reports/aprovals'
        },
        {
          id: 3,
          description: 'Relatórios de culturas oferecidas',
          icon: 'seedling'
        },
      ]
    }
  },
  mounted() {
  },
  methods: {
    
  }
}
</script>
<style scoped>
.card {
  box-shadow: 0 0 2rem 0 rgb(136 152 170 / 25%);
}
</style>